var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52565 15.312C3.54513 15.3942 3.58103 15.4715 3.6312 15.5395C3.68136 15.6074 3.74474 15.6644 3.81753 15.7072C3.89033 15.75 3.97102 15.7776 4.05477 15.7884C4.13851 15.7992 4.22357 15.7929 4.30483 15.77C8.03055 14.7413 11.9653 14.7409 15.6912 15.7689C15.7725 15.7918 15.8575 15.7981 15.9412 15.7873C16.0249 15.7765 16.1056 15.7489 16.1784 15.7062C16.2511 15.6634 16.3145 15.6064 16.3647 15.5385C16.4148 15.4706 16.4507 15.3933 16.4702 15.3112L18.4616 6.8489C18.4882 6.73561 18.4827 6.61713 18.4457 6.5068C18.4086 6.39648 18.3415 6.29868 18.2519 6.22444C18.1623 6.15019 18.0537 6.10244 17.9384 6.08657C17.8231 6.0707 17.7057 6.08733 17.5993 6.1346L13.6475 7.89098C13.5048 7.9544 13.3435 7.96211 13.1954 7.91258C13.0473 7.86305 12.9231 7.75988 12.8473 7.62337L10.5463 3.48163C10.4922 3.3842 10.413 3.30301 10.3169 3.24649C10.2209 3.18996 10.1114 3.16016 9.99997 3.16016C9.88851 3.16016 9.77908 3.18996 9.68302 3.24649C9.58695 3.30301 9.50775 3.3842 9.45362 3.48163L7.15266 7.62337C7.07682 7.75988 6.95263 7.86305 6.80454 7.91258C6.65644 7.96211 6.49517 7.9544 6.35247 7.89098L2.40002 6.13433C2.29369 6.08708 2.17628 6.07044 2.061 6.0863C1.94573 6.10215 1.83718 6.14987 1.74756 6.22409C1.65794 6.2983 1.59081 6.39606 1.55374 6.50635C1.51668 6.61665 1.51113 6.7351 1.53774 6.84837L3.52565 15.312Z",
    stroke: "#FF6636",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.6311C9.16208 12.4563 10.8379 12.4563 12.5 12.6311",
    stroke: "#FF6636",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/Crown.cf41eb4eafcda5f6c5b1983c4d172555.svg";
export { ForwardRef as ReactComponent };